module.exports = __webpack_public_path__ + "trello.ca79c5.svg";